import React from "react";
import AccountDeletion from "./AccountDeletion";
import top from "../../assets/rf/top.webp";
import gear from "../../assets/rf/gear.webp";
import deleteImage from "../../assets/rf/delete.webp";

function RareFindAccountDeletion() {
  return (
    <AccountDeletion
      gameName="Rare Find"
      images={{ top, gear, delete: deleteImage }}
    />
  );
}

export default RareFindAccountDeletion;
